<script setup lang="ts">
import type { TooltipInstance } from '@arco-design/web-vue'

const props = withDefaults(defineProps<{
  title?: string
  contentClass?: string
  popupContainer?: TooltipInstance['$props']['popupContainer']
  effect?: 'dark' | 'light'
  disabled?: boolean
  position?: 'top' | 'right' | 'bottom' | 'left' | 'rt'
}>(), {
  contentClass: '',
  popupContainer: '#__nuxt',
  effect: 'dark',
  disabled: false,
  position: 'top',
})

enum Effect {
  Dark = 'dark',
  Light = 'light',
}

const getBackgroundColor = computed(() => {
  return props.effect === Effect.Dark ? 'var(--color-tooltip-dark)' : 'var(--color-tooltip-light)'
})
const getContentClass = computed(() => {
  return props.effect === Effect.Dark ? '' : 'g-tooltip__light'
})
</script>

<template>
  <a-tooltip
    :content-class="`rounded-8 text-12 line-height-20 ${getContentClass} ${contentClass}`"
    :class="{ hidden: disabled }"
    :background-color="getBackgroundColor"
    :position="position"
    :content="title"
    :popup-container="popupContainer"
    v-bind="$attrs"
  >
    <template v-for="(_, key) in $slots" :key="key" #[key]="scope">
      <slot :name="key" v-bind="scope" />
    </template>
  </a-tooltip>
</template>

<style lang="less">
.g-tooltip {
  &__light {
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.10);
    color: var(--color-text-1)
  }
}
</style>
